/**
 * Free-text money fields (merchant.requesting, merchant.monthly_revenue) hold
 * whatever a merchant or lead vendor typed: "150000", "$50,000", "50k",
 * "$10,000 - $20,000 per month", "$100k+/mo", "Unsure".
 */

/** "150,000" / "$100000" → "$150,000"; anything not purely numeric as typed. */
export function formatLooseCurrency(value: unknown): string {
  if (value == null) return '';
  const raw = String(value).trim();
  if (!raw || !/^[$\s\d,.]+$/.test(raw)) return raw;
  const numeric = Number(raw.replace(/[^0-9.]/g, ''));
  if (!Number.isFinite(numeric) || numeric <= 0) return raw;
  return '$' + Math.round(numeric).toLocaleString('en-US');
}

/**
 * The dollar amount a free-text money value starts with, for sorting and
 * number filters: the first figure, with a k / m suffix applied, so a range
 * sorts by its low end ("$10k - $20k/mo" → 10000, "$100,000+ per month" →
 * 100000). Null when there is no figure ("Unsure").
 */
export function looseCurrencyAmount(value: unknown): number | null {
  if (value == null) return null;
  const match = String(value).toLowerCase().match(/(\d[\d,]*(?:\.\d+)?)\s*(k|m|mm)?\b/);
  if (!match) return null;
  const base = Number(match[1].replace(/,/g, ''));
  if (!Number.isFinite(base)) return null;
  const multiplier = match[2] === 'k' ? 1_000 : match[2] ? 1_000_000 : 1;
  return base * multiplier;
}
